import { Helmet } from "react-helmet-async";
import TroubleShoot from "./TroubleShoot";

const TroubleShootDashboard = () => {
  return (
    <>
      <Helmet>
        <title>Troubleshooting</title>
      </Helmet>
      <TroubleShoot />
    </>
  );
};

export default TroubleShootDashboard;
